import { GridComparatorFn } from '@mui/x-data-grid-premium'
import { RequestPriorityEnum } from '@omnea-app/requests/requestPriority'

export const requestPriorityEnumToNumberMap = {
  [RequestPriorityEnum.LOWEST]: 1,
  [RequestPriorityEnum.LOW]: 2,
  [RequestPriorityEnum.MEDIUM]: 3,
  [RequestPriorityEnum.HIGH]: 4,
  [RequestPriorityEnum.HIGHEST]: 5,
}

export const requestPriorityEnumDataGridComparator: GridComparatorFn<RequestPriorityEnum> = (p1, p2) =>
  requestPriorityEnumToNumberMap[p2] - requestPriorityEnumToNumberMap[p1]
